module.exports = "/dashboard/buttons-380ffd.html";